var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.unseenVisitorCount)?_c('div',{staticClass:"pill__circle visitors-pulse-animation"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }